import React, { useState } from 'react';
import { FaRegCopy, FaSyncAlt, FaSearch } from 'react-icons/fa';
import s from '../styles/ProjectCard.module.css'; // создадим под него модуль
import ProjectSettingsModal from './ProjectModal';
import AutoloadSettingsModal from './AutoloadSettingsModal';
import DeleteProjectButton from './DeleteProjectButton';
import LastReportViewer from './ReportDetails';
import CommentEditor from './CommentEditor';
import UpdateXmlButton from "./UpdateXmlButton";
import { Tooltip } from 'react-tooltip';
import ProjectMenu from './ProjectMenu';
import useIsMobile from "./useIsMobile";
import AvitoStatsContainer from './metrics/AvitoStatsContainer';
import Notifications from './Notifications';
import ProjectReraitSettings from './rerait/ProjectReraitSettings';
import GoogleMetrikaProjectButton from './GoogleMetrikaProjectButton';
import AdsModal from './ads/AdsModal';
import OneProjectToCheckTable from './OneProjectToCheckTable';




const ProjectCard = ({ project, onProjectUpdate }) => {
    const [showModal, setShowModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showAutoloadModal, setShowAutoloadModal] = useState(false);
  const [showReraitModal, setShowReraitModal] = useState(false);
  const [showAdsModal, setShowAdsModal] = useState(false);

    const [copiedField, setCopiedField] = useState(null); // поле, по которому был клик

    const isMobile = useIsMobile(); // true или false

    const handleUpdate = (updatedData) => {
        onProjectUpdate(project.id, updatedData); // сообщаем родителю
        // setShowModal(false); // закрыть модалку
      };

      const copy = (text, key) => {
        if (!text) return;
        navigator.clipboard.writeText(text);
        setCopiedField(key);
        setTimeout(() => setCopiedField(null), 1000);
      };

      const [refreshLoading, setRefreshLoading] = useState(false);

      const refreshProject = async () => {
        setRefreshLoading(true);
        try {
          const res = await fetch('/api/projects/refresh_balance_report', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: project.id }),
          });
      
          const data = await res.json();
      
          if (data.success && data.project) {
            const { bonus, real, avance, last_report } = data.project;
      
            onProjectUpdate(project.id, {
              bonus,
              real,
              avance,
              last_report,
            });
          } else {
            console.error('Ошибка обновления проекта:', data.error);
          }
        } catch (err) {
          console.error('Ошибка сети при обновлении проекта:', err);
        } finally {
          setRefreshLoading(false);
        }
      };
      

  return (
    <div className={s.item_project} data-id={project.id}>
        <div className={s.left_block}>
                <div className={s.id_name_all}>
                    <div className={s.id}>id<p className={s.value_id}>{project.id}</p></div>
                    
                    <div className={s.project}><p className={s.value_project}>{project.project_name}</p></div>
                    <div className={s.hidden_name_div}></div>
                    {isMobile && (
                            <div className={s.mobileMenu}>
                            <ProjectMenu
                              onAutoload={() => setShowAutoloadModal(true)}
                              onRerait={() => setShowReraitModal(true)}
                              adsEdit={() => setShowAdsModal(true)}
                                onEdit={() => setShowModal(true)}
                                onDelete={() => setShowDeleteModal(true)}
                            />
                            </div>
                        )}
            </div>
            

            
            <div className={s.balance_report_div}>
                <div className={s.balance_all}>
                    <div className={s.balance_name_div}>
                      <Notifications project_id={project.id}/>
                      <p className={s.balance_name}>Баланс AVITO</p>  
                    </div>
                    
                    <div
                              className={s.bonus_balance_avance_div}
                              id={`target_bonus_${project.id}`}
                            >
                        <p className={s.bonus_balance_avance_p}>Бонус:</p><p className={s.bonus_p}>{project.bonus != null ? `${project.bonus} ₽` : 'нет данных.'}</p>
                        </div>
                        <div className={s.bonus_balance_avance_div}>
                        <p className={s.bonus_balance_avance_p}>Кошелек:</p><p className={s.balance_p}>{project.real !=null ? `${project.real} ₽` : "нет данных."}</p>
                        </div>

                        <div className={s.bonus_balance_avance_div}>
                        <p className={s.bonus_balance_avance_p}>Аванс:</p><p className={s.avance_p}>{project.avance != null ? `${(project.avance / 100).toFixed(2)} ₽` : 'нет данных.'}</p>
                        </div>
                </div>
                <div className={s.last_report_all}>
                <div className={s.balance_name_div}>
                <button
                        className={s.refresh_batton}
                        onClick={refreshProject}
                        disabled={refreshLoading}
                        title="Обновить"
                        >
                        <FaSyncAlt className={refreshLoading ? s.spin_refresh_report : ''} />
                        </button>
                      <p className={s.balance_name}>Отчет загрузки</p>  
                    </div>
                       <LastReportViewer lastReport={project.last_report} />
                </div>
            </div>
        </div>
       
        <div className={s.link_comment_all}>
             <div className={s.table_xml_div}>
            <div className={s.table_all}>
                    <a className={
                                project.google_table?.startsWith("https://")
                                ? s.table_href
                                : s.table_href_invalid
                            }
                            href={project.google_table}
                            target="_blank"
                            rel="noopener noreferrer"
                            title={
                                project.google_table?.startsWith("https://")
                                ? "Открыть таблицу"
                                : "Добавьте таблицу"
                            }
                            >Открыть таблицу</a>
                
                <div data-tooltip-id="my-tooltip" data-tooltip-content="Кликни, чтобы скопировать" className={s.copy}>
                    <FaRegCopy onClick={() => copy(project.google_table, "google_table_" + project.id)} />
                    {copiedField === "google_table_" + project.id && (
                    <span className={s.copied_text}>Скопировано</span>
                    )}
                </div>
            </div>

            <div className={s.xml_all}>
                <a className={s.xml_href} href={project.xml_url} target="_blank" rel="noopener noreferrer">Открыть XML</a>
                <UpdateXmlButton projectId={project.id} />
                <div
                    data-tooltip-id="my-tooltip"
                    data-tooltip-content="Проверить файл"
                    className={s.copy}
                    onClick={() =>
                        window.open(`https://autoload.avito.ru/format/xmlcheck/#ad_457598`, "_blank")
                    }
                    >
                    <FaSearch />
                    </div>
                <div data-tooltip-id="my-tooltip" data-tooltip-content="Кликни, чтобы скопировать" className={s.copy}>
                    <FaRegCopy onClick={() => copy(project.xml_url, "xml_" + project.id)} />
                    {copiedField === "xml_" + project.id && (
                    <span className={s.copied_text}>Скопировано</span>
                    )}
                </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'baseline', gap: '10px', justifyContent: 'flex-start' }}>
              <GoogleMetrikaProjectButton projectId={project.id} />
              <OneProjectToCheckTable projectId={project.id} />          
            </div>


        </div>
          <CommentEditor projectId={project.id} initialComment={project.comment} />  
        </div>
        
         

        
            <AvitoStatsContainer project={project} />
             <div className={s.settings_modal_div}>
                
                    {/* МОДАЛКА */}
                    {showModal && (
                        <ProjectSettingsModal
                        project={project}
                        onClose={() => setShowModal(false)}
                        onSave={handleUpdate}
                        onOpenAutoload={() => setShowAutoloadModal(true)}
                        />
                    )}
            </div>
                  {showAutoloadModal && (
                    <AutoloadSettingsModal
                      project={project}
                      onClose={() => setShowAutoloadModal(false)}
                    />
                  )}
            {showDeleteModal && (
                <DeleteProjectButton
                    projectId={project.id}
                    onDelete={(id) => {
                    setShowDeleteModal(false);
                    onProjectUpdate(id, { _delete: true });
                    }}
                    onCancel={() => setShowDeleteModal(false)} // 👈 для кнопки "Отмена"
                />
                )}

            {showReraitModal && (
              <div className={s.reraitOverlay}>
                <div className={s.reraitModalCard}>
                  <div className={s.reraitModalHeader}>
                    <button
                      type="button"
                      className={s.reraitClose}
                      onClick={() => setShowReraitModal(false)}
                    >
                      ✕
                    </button>
                  </div>
                  <ProjectReraitSettings project={project} />
                </div>
              </div>
            )}

            {showAdsModal && (
              <AdsModal
                project={project}
                onClose={() => setShowAdsModal(false)}
                endpoint="/api/ads/get_ads"
              />
            )}
     
            {/* <div className={s.roject_menu_div}>
               <ProjectMenu
            onEdit={() => setShowModal(true)}
            onDelete={() => setShowDeleteModal(true)} // 👈 это вызывает появление модалки
            /> 
            </div> */}
            {/* <AvitoStats projectId={project.id} /> */}
            
            {!isMobile && (
                <div className={s.desktopMenu}>
                    <ProjectMenu
                    onAutoload={() => setShowAutoloadModal(true)}
                    onRerait={() => setShowReraitModal(true)}
                  adsEdit={() => setShowAdsModal(true)}
                    onEdit={() => setShowModal(true)}
                    onDelete={() => setShowDeleteModal(true)}
                    />
                </div>
                )}

            <div className={s.table_xml_div_2}>
            <div className={s.table_all}>
                <a className={
                        project.google_table?.startsWith("https://")
                        ? s.table_href
                        : s.table_href_invalid
                    }
                    href={project.google_table}
                    target="_blank"
                    rel="noopener noreferrer"
                    title={
                        project.google_table?.startsWith("https://")
                        ? "Открыть таблицу"
                        : "Добавьте таблицу"
                    }
                    >Открыть таблицу</a>

                <div data-tooltip-id="my-tooltip" data-tooltip-content="Кликни, чтобы скопировать" className={s.copy}>
                    <FaRegCopy onClick={() => copy(project.google_table, "google_table_" + project.id)} />
                    {copiedField === "google_table_" + project.id && (
                    <span className={s.copied_text}>Скопировано</span>
                    )}
                </div>
            </div>

            <div className={s.xml_all}>
                <a className={s.xml_href} href={project.xml_url} target="_blank" rel="noopener noreferrer">Открыть XML</a>
                <UpdateXmlButton projectId={project.id} />
                <div
                    data-tooltip-id="my-tooltip"
                    data-tooltip-content="Проверить файл"
                    className={s.copy}
                    onClick={() =>
                        window.open(`https://autoload.avito.ru/format/xmlcheck/#ad_457598`, "_blank")
                    }
                    >
                    <FaSearch />
                    </div>

                <div data-tooltip-id="my-tooltip" data-tooltip-content="Кликни, чтобы скопировать" className={s.copy}>
                        <FaRegCopy onClick={() => copy(project.xml_url, "xml_" + project.id)} />
                        {copiedField === "xml_" + project.id && (
                        <span className={s.copied_text}>Скопировано</span>
                        )}
                    </div>
            </div>
        </div>
        

        
            
          
           
            <Tooltip
                id="my-tooltip"
                place="top"         // top, bottom, left, right
                variant="light"      // dark (по умолчанию), light, success, error, info
                delayShow={200}
                style={{ fontSize: "10px" }} // ✅ теперь кастомизация через style
                />
            
          </div>

  );
};

// const copy = (text) => {
//   navigator.clipboard.writeText(text);
//   alert('Скопировано: ' + text);
// };
// const copy = (text) => {
//     if (!text) return;
//     navigator.clipboard.writeText(text);
//     toast.success("Скопировано!");
//   };



export default ProjectCard;
